import { render, staticRenderFns } from "./add-task.vue?vue&type=template&id=4f56a5fc&scoped=true"
import script from "./add-task.vue?vue&type=script&lang=js"
export * from "./add-task.vue?vue&type=script&lang=js"
import style0 from "./add-task.vue?vue&type=style&index=0&id=4f56a5fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f56a5fc",
  null
  
)

export default component.exports